import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { setInitialAuthState } from "../redux/actions/auth_action";
import { isValidToken } from "../utils/authUtils";

function MobileProtectedRoutes() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const accessToken = useMemo(() => {
    try {
      const raw = localStorage.getItem("profile");
      if (!raw) return null;
      return JSON.parse(raw)?.token ?? null;
    } catch {
      return null;
    }
  }, []);

  const isJwt = accessToken?.split(".").length === 3;
  const isAuthed = isJwt ? isValidToken(accessToken) : Boolean(accessToken);

  useEffect(() => {
    if (!isAuthed) {
      dispatch(setInitialAuthState(navigate));
    }
  }, [isAuthed, dispatch, navigate]);

  return isAuthed ? (
    <main className="min-h-screen h-full bg-[#f5f5f5] pb-8">
      <Outlet />
    </main>
  ) : (
    <Navigate to="/" replace />
  );
}

export default MobileProtectedRoutes;
